module.exports = {
  tableSettings: require('./dist/tableSettings'),
  widgetSettings: require('./dist/widgetSettings')
};